const autoTemplateComponent = async () => {
  // Import all modules from the /components directory if they exist
  let components = await import('../../../components/**/*.js')

  if (components) {
    const allComponents = Object.keys(components)
    allComponents.forEach((component) => {
      // console.log(document.getElementById('js-' + component))

      if (document.getElementById('js-' + component) !== null) {
        const mod = components[component][component]

        if (mod) {
         //  console.log(mod)
          mod()
        }
      }
    })
  }
}

export default autoTemplateComponent
